import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isMobile from 'ismobilejs';

import { linkEmailChannel, unlinkChannel } from '../../actions/integrations';
import CircularLoading from '../CircularLoading';
import { IOS_SCALE_STYLING } from '../../constants/styles';

const styles = {
    isAppleDevice: IOS_SCALE_STYLING.FOURTEEN_PIXELS,
};

export class EmailChannelContentComponent extends Component {
    static propTypes = {
        _id: PropTypes.string.isRequired,
        category: PropTypes.string.isRequired,
        client: PropTypes.object,
        emailChangeAddress: PropTypes.string.isRequired,
        emailFieldLabel: PropTypes.string.isRequired,
        emailFieldPlaceholder: PropTypes.string.isRequired,
        emailFormButton: PropTypes.string.isRequired,
        linkColor: PropTypes.string,
        linked: PropTypes.bool.isRequired,
        linkEmailChannel: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
        unlinkChannel: PropTypes.func.isRequired,
    };

    state = {
        email: '',
        showButton: false,
        hasFocus: false,
        hasError: false,
        isWorking: false,
    };

    onFormSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const { linkEmailChannel, _id, type } = this.props;

        // http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
        const regex = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

        const email = this._input.value;

        var isValid = regex.test(email);

        if (isValid) {
            this.setState({
                email: '',
                hasError: false,
                isWorking: true,
                showButton: false,
            });

            return linkEmailChannel({
                type,
                integrationId: _id,
                address: email,
            });
        } else {
            this.setState({
                hasError: true,
            });
        }
    };

    onFocus = (e) => {
        e.preventDefault();
        this.setState({
            showButton: true,
            hasFocus: true,
        });
    };

    onBlur = (e) => {
        e.preventDefault();
        this.setState({ hasFocus: false });
    };

    onUnlinkClick = (e) => {
        e.preventDefault();
        const { unlinkChannel, type } = this.props;
        this.setState({ isWorking: true });
        unlinkChannel(type);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.linked !== nextProps.linked) {
            this.setState({
                isWorking: false,
            });
        }
    }

    render() {
        const {
            client,
            emailChangeAddress,
            emailFieldLabel,
            emailFieldPlaceholder,
            emailFormButton,
            linkColor,
            linked,
        } = this.props;

        const { hasError, hasFocus, showButton, isWorking } = this.state;

        const buttonStyle = {
            borderColor: `#${linkColor}`,
            backgroundColor: `#${linkColor}`,
        };

        const inputStyle =
            hasFocus && !hasError
                ? {
                      borderBottomColor: `#${linkColor}`,
                  }
                : {};

        const spinner = isWorking ? <CircularLoading /> : null;
        let content;

        if (linked) {
            content = (
                <div>
                    <p>
                        Connected as <strong>{client.displayName}</strong>
                    </p>
                    {!isWorking && (
                        <p>
                            <a onClick={this.onUnlinkClick} className="cancel-link">
                                {emailChangeAddress}
                            </a>
                        </p>
                    )}
                    {spinner}
                </div>
            );
        } else {
            const button = showButton ? (
                <button type="submit" className="btn btn-primary" style={buttonStyle} onClick={this.save}>
                    {emailFormButton}
                </button>
            ) : null;

            content = (
                <form onSubmit={this.onFormSubmit} className="email-linking" noValidate>
                    <div className={hasError ? 'input-group has-error' : 'input-group'}>
                        <label>{emailFieldLabel}</label>
                        <input
                            type="email"
                            className="input email-input"
                            style={{ ...inputStyle, ...(isMobile().apple.device && styles.isAppleDevice) }}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            placeholder={emailFieldPlaceholder}
                            disabled={isWorking}
                            ref={(c) => (this._input = c)}
                        />
                    </div>
                    {button}
                    {spinner}
                </form>
            );
        }

        return <div className="email-linking">{content}</div>;
    }
}

const mapStateToProps = ({ config, ui: { text } }) => {
    return {
        linkColor: config.colors.linkColor,
        emailChangeAddress: text.emailChangeAddress,
        emailFieldLabel: text.emailFieldLabel,
        emailFieldPlaceholder: text.emailFieldPlaceholder,
        emailFormButton: text.emailFormButton,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            linkEmailChannel,
            unlinkChannel,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(EmailChannelContentComponent);
